/** Title strip of a left-dock drawer: title, a mono sub-line, close button. */
import { useT } from '../../i18n';
import { Icon } from '../common/Icon';
import d from './drawers.module.css';
import { hudStore } from './hudStore';

export function DrawerHead({ title, sub }: { title: string; sub?: string }) {
  const t = useT();
  return (
    <div className={d.head}>
      <span className={d.title}>{title}</span>
      {sub && <span className={d.sub}>{sub}</span>}
      <button
        type="button"
        className={d.x}
        title={t('ui.close')}
        onClick={() => hudStore.getState().setPanel(null)}
      >
        <Icon name="close" size={14} />
      </button>
    </div>
  );
}
